import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ReorderAction,
  ReorderButtonsComponent,
} from '../reorder-buttons/reorder-buttons.component';
import { TankSummaryComponent } from '../tank-transfer/tank-summary/tank-summary.component';
import { TrashButtonComponent } from '../trash-button/trash-button.component';
import { VesselTank } from '../vessel-tank.model';

export interface AuxEngineConsumptionBreakdown {
  ballastOperations: number;
  cargoHeating: number;
  tankCleaning: number;
  cargoDischarging: number;
  bunkerHeating: number;
}

@Component({
  selector: 're-tank-consumption',
  templateUrl: './tank-consumption.component.html',
  styleUrl: './tank-consumption.component.css',
  imports: [
    ReactiveFormsModule,
    ReorderButtonsComponent,
    TankSummaryComponent,
    TrashButtonComponent,
    FormsModule,
  ],
})
export class TankConsumptionComponent implements OnInit {
  @Input({ required: true }) from!: VesselTank;
  @Input({ required: true }) action: any;
  @Output() delete = new EventEmitter<any>();
  @Output() reorder = new EventEmitter<{ id: number; action: ReorderAction }>();
  progress2 = 0;

  mainEngineConsumption = 0;

  fromProgress = 0;

  auxEngineConsumptions: AuxEngineConsumptionBreakdown = {
    ballastOperations: 0,
    bunkerHeating: 0,
    tankCleaning: 0,
    cargoHeating: 0,
    cargoDischarging: 0,
  };

  get totalAuxEngineConsumptions(): number {
    const {
      ballastOperations,
      bunkerHeating,
      tankCleaning,
      cargoHeating,
      cargoDischarging,
    } = this.auxEngineConsumptions;

    return (
      ballastOperations +
      bunkerHeating +
      tankCleaning +
      cargoDischarging +
      cargoHeating
    );
  }

  get totalConsumeAmount() {
    return this.mainEngineConsumption + this.totalAuxEngineConsumptions;
  }

  ngOnInit() {
    this.calculateProgress();
  }

  get isValid(): boolean {
    return this.totalConsumeAmount <= this.maxConsumeAmount;
  }

  get maxConsumeAmount(): number {
    return this.from.content?.quantity ?? 0;
  }

  onDelete() {
    this.delete.emit(this.action);
  }

  onModelChange() {
    this.action.tankOperations = [
      {
        tank: {
          ...this.from,
        },
        fuel: {
          fuelGrade: this.from.content?.fuelGrade,
          quantity: -this.totalConsumeAmount,
        },
      },
    ];
  }

  onReorder(action: any) {
    this.reorder.emit({
      id: this.action.id,
      action: action,
    });
  }

  calculateProgress() {
    const capacity = this.from.capacity ?? 0;
    const quantity = this.from.content?.quantity ?? 0;

    this.fromProgress =
      capacity > 0
        ? ((quantity - this.totalConsumeAmount) / capacity) * 100
        : 0;

    // Quick check to ensure progressbar doesn't grow beyond bounds
    if (this.totalConsumeAmount >= this.maxConsumeAmount) {
      this.progress2 =
        capacity > 0 ? (this.maxConsumeAmount / capacity) * 100 : 0;
      return;
    }

    this.progress2 =
      capacity > 0 ? (this.totalConsumeAmount / capacity) * 100 : 0;
  }

  onInputChange(): void {
    this.calculateProgress();
  }
}
